document.addEventListener('click', function(event) {
    if (event.target.classList.contains('article_summary__item')) {
        var summaryIndex = event.target.getAttribute('data-index');
        var targetHeader = document.querySelector('.article-template__content .article__content h2[data-index="' + summaryIndex + '"]');
        if (targetHeader) {
            const targetPosition = targetHeader.getBoundingClientRect().top + window.scrollY;
    
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    }
});